import Swiper, { Navigation, Pagination, Thumbs, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Thumbs, Autoplay, EffectFade]);
window.swiperObj = Swiper